import { memo } from 'react'
import { clsx } from 'clsx'

import styles from './ra-grid-item.module.scss'

interface RaGridItemProps {
  children: React.ReactNode
  xs?: number
  sm?: number
  md?: number
  lg?: number
  dataName?: string
  customClassNames?: any
  noMargin?: boolean
  [x: string]: any
}

export const RaGridItem = memo(
  ({
    children,
    xs = 12,
    sm = 12,
    md = 6,
    lg = 4,
    customClassNames,
    dataName,
    noMargin = false,
    ...props
  }: RaGridItemProps) => {
    if (!children) return null
    return (
      <div
        {...props}
        className={clsx(
          styles['ra-grid-item'],
          noMargin && styles['ra-grid-item--no-margin'],
          customClassNames && customClassNames
        )}
        style={
          {
            '--xs-cols': xs,
            '--sm-cols': sm,
            '--md-cols': md,
            '--lg-cols': lg,
            ...props.style,
          } as React.CSSProperties
        }
        data-name={dataName}>
        {children}
      </div>
    )
  }
)

RaGridItem.displayName = 'RaGridItem'
